import { render, staticRenderFns } from "./ThSort.vue?vue&type=template&id=750fb3d2&scoped=true&"
import script from "./ThSort.vue?vue&type=script&lang=js&"
export * from "./ThSort.vue?vue&type=script&lang=js&"
import style0 from "./ThSort.vue?vue&type=style&index=0&id=750fb3d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750fb3d2",
  null
  
)

export default component.exports